/**
 * Converts a single value into a class name string
 * @param {string|number|object|Array} value - The value to convert
 * @returns {string} The resulting class name string
 */
const convertToClassName = (value) => {
  const result = '';

  // Handle primitive values (strings and numbers)
  if (typeof value === 'string' || typeof value === 'number') {
    return String(value);
  }

  // Handle arrays
  if (Array.isArray(value)) {
    return value
      .map((item) => convertToClassName(item))
      .filter(Boolean)
      .join(' ');
  }

  // Handle objects
  if (value && typeof value === 'object') {
    return Object.entries(value)
      .filter(([_, isActive]) => Boolean(isActive))
      .map(([className]) => className)
      .join(' ');
  }

  return result;
};

/**
 * Conditionally joins class names together
 * @param {...(string|number|object|Array)} args - Class names to join
 * @returns {string} The joined class names
 */
const clsx = (...args) => {
  return args
    .map((arg) => convertToClassName(arg))
    .filter(Boolean)
    .join(' ');
};

export default clsx;
